// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native";
import colors from "../../config/colors";
import fonts from "../../config/fonts";
const OwnStorageStyle = StyleSheet.create({
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: 12,
    color: colors.green,
    borderRadius: 16,
    shadowColor: colors.greenWater,
    backgroundColor: colors.white,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 3,
    marginTop: 10,
    marginBottom: 5,
    fontFamily: fonts.regular,
  },
  iconContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.white,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    flex: 1,
    color: colors.green,
    fontFamily: fonts.regular,
  },
  content: {
    paddingHorizontal: 12,
    paddingVertical: 16,
    marginBottom: 10,
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  labelContainer: {
    width: "50%",
  },
  label: {
    fontSize: 16,
    fontWeight: "bold",
    color: colors.green,
    fontFamily: fonts.regular,
  },
  inputContainer: {
    width: "50%",
  },
  input: {
    paddingVertical: 8,
    fontSize: 16,
    borderWidth: 1,
    borderColor: colors.white,
    color: colors.black,
  },
  buttonContainer: {
    marginTop: 16,
    alignItems: "center",
  },
  button: {
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  buttonText: {
    fontSize: 18,
    fontWeight: "bold",
    color: colors.white,
    fontFamily: fonts.regular,
  },
});

export default OwnStorageStyle;
